import { FetchResult } from "@apollo/client";
import { Button, Classes, Dialog, Intent } from "@blueprintjs/core";
import React from "react";
import { GlobalStateContext } from "../../Context";
import { UserLanguage } from "../../lang/lang";
import { ActionStringCollection } from "../../lang/types";
import { DialogBody, DialogFooter } from "../dialog/Dialog";
import { parseError } from "../Error";
import { FlexGrow, FlexRowStretch } from "../flex/Flex";
import { SuccessCard } from "../SuccessCard";
import { ErrorCard } from "./Error";

interface DeleteModalProps<R> {
  open: boolean;
  texts: ActionStringCollection;
  onClose: () => void;
  mutation: (id: number) => Promise<FetchResult<R>>;
  onSuccess: () => void;
  resetOnClose?: boolean;
  id?: number;
  type: string;
  prettyPrint?: string;
}

interface DeleteModalState {
  submitting: boolean;
  success: boolean;
  error: any | null;
}

export interface DeleteStateHelper {
  open: boolean;
  id?: number;
  prettyPrint?: string;
}

export class DeleteModal<R = any> extends React.Component<
  DeleteModalProps<R>,
  DeleteModalState
> {
  private getInitState = () => ({
    submitting: false,
    success: false,
    error: null,
  });

  state = this.getInitState();

  private onClose() {
    if (this.props.resetOnClose) this.setState(this.getInitState());
    this.props.onClose();
  }

  private onSubmit() {
    if (!this.props.id) return;
    console.log("delete modal in submit", this.props.id);

    this.setState({ submitting: true });
    this.props
      .mutation(this.props.id)
      .then((v) => {
        this.setState({ success: true });
        console.log("success?", v);
        setTimeout(() => {
          this.setState({
            submitting: false,
            error: null,
            success: false,
          });
          this.props.onSuccess();
        }, 1000);
      })
      .catch((e) => {
        console.log("error", e);
        this.setState({ success: false, error: parseError(e) });
        setTimeout(() => this.setState({ submitting: false }), 500);
      });
  }

  render = () => {
    return (
      <GlobalStateContext.Consumer>
        {(global_state) => (
          <Dialog
            isOpen={this.props.open && this.props.id !== undefined}
            title={this.props.texts.delete.title}
            onClose={() => this.onClose()}
            className={global_state.dark_mode ? Classes.DARK : ""}
          >
            <DialogBody>
              <ErrorCard error={this.state.error} />
              <SuccessCard
                text={this.props.texts.delete.success}
                display={this.state.error === null && this.state.success}
              />
              {UserLanguage().global.deleteModal.warning(
                this.props.id || 0,
                this.props.type,
                this.props.prettyPrint
              )}
            </DialogBody>
            <DialogFooter>
              <FlexRowStretch>
                <Button
                  disabled={this.state.submitting}
                  onClick={() => this.onClose()}
                  style={{ float: "left" }}
                >
                  {UserLanguage().actions.cancel}
                </Button>
                <FlexGrow />
                <Button
                  disabled={this.state.submitting || !this.props.id}
                  intent={Intent.DANGER}
                  onClick={() => this.onSubmit()}
                >
                  {UserLanguage().actions.delete}
                </Button>
              </FlexRowStretch>
            </DialogFooter>
          </Dialog>
        )}
      </GlobalStateContext.Consumer>
    );
  };
}
